"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserImageAnnotationComponentParameters = void 0;
exports.UserImageAnnotationComponentParameters = [
    {
        id: 'image',
        label: 'Image',
        description: 'Input Param - Specifies the image file to be annotated.',
        type: 'file',
        paramType: 'FILE',
        required: true,
    },
    {
        id: 'enableRectangle',
        label: 'Enable Rectangle',
        description: 'Input Param - Boolean indicating whether rectangle annotations are enabled.',
        type: 'boolean',
        paramType: 'BOOLEAN',
        required: false,
    },
    {
        id: 'enableCircle',
        label: 'Enable Circle',
        description: 'Input Param - Boolean indicating whether circle annotations are enabled.',
        type: 'boolean',
        paramType: 'BOOLEAN',
        required: false,
    },
    {
        id: 'enableFreeHand',
        label: 'Enable Freehand',
        description: 'Input Param - Boolean indicating whether freehand annotations are enabled.',
        type: 'boolean',
        paramType: 'BOOLEAN',
        required: false,
    },
    {
        id: 'enableAll',
        label: 'Enable All Annotations',
        description: 'Input Param - Boolean indicating whether all annotation types are enabled.',
        type: 'boolean',
        paramType: 'BOOLEAN',
        required: false,
    },
    {
        id: 'mask',
        label: 'Mask',
        description: 'Output Param - Captures the mask file for the annotations.',
        type: 'output',
        paramType: 'FILE',
        required: true,
    },
    {
        id: 'drawingStrokes',
        label: 'Drawing Strokes',
        description: 'Output Param - Captures the drawing strokes as a JSON file.',
        type: 'output',
        paramType: 'FILE',
        required: false,
    },
];
//# sourceMappingURL=UserImageAnnotationComponent.js.map